export enum ToastStatus {
    Success = 'success',
    Error = 'error',
    Info = 'info',
    Warning = 'warning',
}

export enum ToastDisplayType {
    Inline = 'inline',
    Snack = 'snack',
}
export type ActionButton =
    | { name: string; action: () => void }
    | { name: string; href: string; target?: '_self' | '_blank' };
